export default __webpack_public_path__ + "static/media/goshen80.eb8d4b1b.jpg";